import React from 'react'
import styled, { css } from 'styled-components'

const StyledIsland = styled.div`
  background-image: url("${props => props.image}");
  background-position: top;
  background-repeat: no-repeat;
  background-size: cover;
  min-height: 60vw;
  width: 100%;
  align-items: center;
  display: flex;
  padding: 3rem;
  @media screen and (max-width:50rem) {
     padding:5vw;
  }
`

export const Island = ({ image, children }) => {
  return (
    <StyledIsland image={image} >{children}</StyledIsland>
  )
}

const StyledIslandCaption = styled.div`
  height: 100%;
  justify-self: flex-start;
  width: 50%;
  background: rgba(53,22,9,.767);
  color: hsla(0,0%,100%,.85);
  font-size: 1.1rem;
  max-width: 50rem;
  padding: 0 1rem;
  padding-bottom: 1.5rem;

  ${props => props.alignment === 'center'
    ? css`
      justify-self: center;
      margin: 0 auto;
    `
    : null}

  @media screen and (max-width:50rem) {
     width:100%
  }
`

export const IslandCaption = ({ children, alignment }) => {
  return <StyledIslandCaption alignment={alignment}>{children}</StyledIslandCaption>
}
